module.exports = __webpack_public_path__ + "static/media/4.efaff7e4.JPG";